import { Component, Input, OnInit } from '@angular/core';

import { Observable, Subscription } from 'rxjs';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { StyleTypesApiEnum } from '../../../../api/styles/enum/style-types-api.enum';
import { Style } from '../../../Styles/models/style.model';
import { StylesService } from '../../../Styles/services/styles.service';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { DialogIoModel } from '../../../../Core/Dialogs/models/dialog-io.model';
import { ConfirmDialogComponent } from '../ConfirmDialog/confirm-dialog.component';
import { ConfirmDialogModel } from '../../models/confirm-dialog.model';
import { SaveStylesDialogComponent } from '../SaveStylesDialog/save-styles-dialog.component';
import { SaveTwigTemplateDialogVariableMap } from '../../models/save-twig-template-dialog-variable-map.model';

@Component({
    selector: 'agpr-save-twig-template-dialog',
    templateUrl: './save-twig-template-dialog.component.html',
    styleUrls: ['./save-twig-template-dialog.component.scss'],
    standalone: false
})
export class SaveTwigTemplateDialogComponent extends AbstractDialogComponent implements OnInit {
    @Input() confirmAction: () => Observable<any>;
    @Input() set type(type: StyleTypesApiEnum) {
        this._type = type;
        this.setDocumentation();
    }
    @Input() inputStyle: Style;
    @Input() defaultTemplate: string;

    public _type: StyleTypesApiEnum;
    public okLabel: string = 'Styles.saveStylesDialog.saveLabel';
    public heading: string = 'Styles.saveTwigTemplateDialog.header';
    public headingType: string = 'Styles.saveTwigTemplateDialog.type';
    public stylesList: Style[];
    public existingOptions: Style[];
    public newStyleName: string = '';
    public formValid: boolean = false;
    public existingStyleModel: Style;
    public messageSeverityEnum = messageSeverityEnum;
    public buttonTypesEnum = ButtonTypesEnum;
    public documentationArray: any[];

    private subscriptions: Subscription[] = [];

    constructor(
        public coreDialogService: CoreDialogService,
        private stylesService: StylesService
    ) {
        super(coreDialogService, 'SaveTwigTemplate');

        this.subscriptions.push(
            this.stylesService.all$.subscribe(
                styles => {
                    this.stylesList = styles;
                }
            )
        );
    }

    ngOnInit(): void {
        this.validate();
    }

    ok() {
        const io: DialogIoModel = {
            inputs: {
                type: this._type,
                inputStyle: this.inputStyle
            },
            outputs: {
                dialogClose: (response) => {
                    if (response) {
                        this.closeDialog(response);
                    }
                }
            }
        };
        this.coreDialogService.open(SaveStylesDialogComponent, io);
    }

    /**
     * Action when the user clicks the "Cancel" button, or closes the dialog via the "X" in the header
     */
    cancel(): void {
        this.closeDialog(false);
    }

    public validate(): void {
        this.formValid = !!(this.inputStyle &&
            this.inputStyle.template &&
            this.inputStyle.template.template &&
            this.inputStyle.template.template.length);
    }

    public resetTemplate(): void {
        const confirmConfig: ConfirmDialogModel = {
            inputs: {
                id: 'saveTwigTemplateDialog.confirmResetDialog',
                heading: 'Styles.saveTwigTemplateDialog.confirmResetHeading',
                alertMessage: 'Styles.saveTwigTemplateDialog.confirmResetToDefaultMessage',
                alertType: messageSeverityEnum.warning,
                message: 'Styles.saveTwigTemplateDialog.confirmResetToDefaultMessageAreYouSure',
                okLabel: 'Styles.saveTwigTemplateDialog.resetToDefault'
            },
            outputs: {
                dialogClose: (confirmed: boolean) => {
                    if (confirmed) {
                        this.inputStyle.template.template = this.defaultTemplate;
                    }
                }
            }
        };
        this.coreDialogService.open(ConfirmDialogComponent, confirmConfig);
    }

    public setDocumentation(): void {
        this.documentationArray = SaveTwigTemplateDialogVariableMap.get(this._type);
    }
}
